import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
// eslint-disable-next-line import/no-cycle
import counterReducer from './features/counter/counterSlice';
import workflowReducer from './features/workflow/workflowSlice';
import exchangesReducer from './features/exchanges/exchangesSlice';
import uploadReducer from './features/upload/uploadSlice';
import processorReducer from './features/processor/processorSlice';

export default function createRootReducer(history: History) {
  return combineReducers({
    router: connectRouter(history),
    counter: counterReducer,
    workflow: workflowReducer,
    exchanges: exchangesReducer,
    upload: uploadReducer,
    processor: processorReducer,
  });
}
